export class Currency {
  public id: number;
  public value: string;
  public symbol = '$';
  public code: string;
  public decimals: number;
  public separator_decimals: string;
  public separator_thousands: string;
  public locale_id = 'es-CL';

  constructor(rawData) {
    Object.assign(this, rawData);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/currency.model.ts